import z from "zod";
import { messageSchema } from "@/shared/messages";

// Tools
export const llmToolSchema = z.object({
  name: z.string(),
  description: z.string(),
  schema: z.object({
    input: z.instanceof(z.ZodObject),
    output: z.instanceof(z.ZodObject),
  }),
  run: z.function({
    input: [z.record(z.string(), z.any())],
    output: z.union([
      z.object({
        success: z.boolean(),
        output: z.record(z.string(), z.any()).optional(),
        error: z.string().optional(),
      }),
      z.promise(
        z.object({
          success: z.boolean(),
          output: z.record(z.string(), z.any()).optional(),
          error: z.string().optional(),
        }),
      ),
    ]),
  }),
});

/**
 * Represents a tool definition for an LLM.
 */
export type LLMToolDefinition = z.infer<typeof llmToolSchema>;

// Resources
export const llmResourcesSchema = z.object({
  messages: z.array(messageSchema),
  tools: z.array(llmToolSchema),
});

/**
 * Represents the common set of resources passed to an LLM for a generation job.
 */
export type LLMResources = z.infer<typeof llmResourcesSchema>;
